<template>
  <div>
      <!-- <Header :isLight="isLight" :isMenuLight="isMenuLight" class="static-header"></Header> -->
      <div class="header clearfix">
        <div class="logo fl">
          <span>我要举报</span>
        </div>
      </div>
      <div class="container">
          <!-- <h2 class="page-title">在线举报</h2> -->
          <div class="form">
              <Form ref="form" :model="form" :rules="ruleValidate" :label-width="125">
                  <div class="clearfix">
                      <div class="report-contact-wrapper clearfix">
                          <div class="report-contact report-contact-left">
                              <h3 class="report-item-title">举报信息</h3>
                              <FormItem prop="itemId" class="query-type form-item-square" label="举报事项：" v-clickoutside="handleClose">
                                  <Input v-model="form.itemId" v-show="false"></Input>
                                  <div class="multi-select" @click="isDropDown=!isDropDown">
                                      <span class="multi-select-placeholder" v-show="!selectedList.length">请选择举报事项</span>
                                      <div class="selected-list">
                                          <span class="tag" v-for="(item,index) in selectedList" :key="item.id">{{item.dicName}}
                                              <Icon type="ios-close-empty" @click.native.stop="handleRemove(index)"></Icon>
                                          </span>
                                      </div>
                                      <Icon type="chevron-down" v-show="!isDropDown"></Icon>
                                      <Icon type="chevron-up" v-show="isDropDown"></Icon>
                                  </div>

                                  <div class="query-type-list-wrapper" v-show="isDropDown">
                                      <ul class="query-type-list">
                                          <li v-for="(item,index) in list" :key="item.id" class="item" :class="{sleceted:item.sleceted}" @click="handleChoose(index)">{{item.dicName}}</li>
                                      </ul>
                                  </div>
                              </FormItem>
                              <FormItem prop="entityType" class="form-item-square person-type" label="被举报人类型：">
                                  <CheckboxGroup v-model="form.entityType" @on-change="handleCheckbox">
                                      <Checkbox label="1">员工</Checkbox>
                                      <Checkbox label="2">合作伙伴</Checkbox>
                                  </CheckboxGroup>
                              </FormItem>
                              <div class="form-item-square" v-if="personSelected">
                                  <div class="report-list">
                                      <div v-for="(item, index) in form.persons" :key="index" class="clearfix">
                                          <div class="top clearfix">
                                              <span class="type fl">员工</span>
                                              <div class="btn-group fr">
                                                  <span class="btn-add btn-handle" @click="handleAddPerson">添加</span>
                                                  <span class="btn-del btn-handle" @click="handleDeletePerson(index)">删除</span>
                                              </div>
                                          </div>
                                          <FormItem label="姓名：" :prop="'persons.' + index + '.name'" :rules="[{required: true, message: '请输入被举报人姓名', trigger: 'blur'},
                                          { type: 'string', min: 2, message: '限制2-10字符', trigger: 'blur' }]">
                                              <Input type="text" v-model.trim="item.name" placeholder="" :maxlength="10"></Input>
                                          </FormItem>
                                          <FormItem label="工号：">
                                              <Input type="text" v-model.trim="item.empId" :maxlength="10"></Input>
                                          </FormItem>
                                          <FormItem label="部门：">
                                              <Input type="text" v-model.trim="item.department" :maxlength="20"></Input>
                                          </FormItem>
                                          <FormItem label="职位：">
                                              <Input type="text" v-model.trim="item.position" :maxlength="20"></Input>
                                          </FormItem>
                                      </div>
                                  </div>
                              </div>
                              <div class="form-item-square" v-if="companySelected">
                                  <div class="report-list">
                                      <div v-for="(item, index) in form.companys" :key="index" class="clearfix">
                                          <div class="top clearfix">
                                              <span class="type fl">合作伙伴</span>
                                              <div class="btn-group fr">
                                                  <span class="btn-add btn-handle" @click="handleAddCompany">添加</span>
                                                  <span class="btn-del btn-handle" @click="handleDeleteCompany(index)">删除</span>
                                              </div>
                                          </div>
                                          <FormItem label="姓名：">
                                              <Input type="text" v-model.trim="item.name" :maxlength="10"></Input>
                                          </FormItem>
                                          <FormItem label="公司：" :prop="'companys.' + index + '.companyName'" :rules="[{required: true, message: '请输入被举报人公司', trigger: 'blur'},
                                          { type: 'string', min: 2, message: '限制2-30字符', trigger: 'blur' }]">
                                              <Input type="text" v-model.trim="item.companyName" :maxlength="30"></Input>
                                          </FormItem>
                                          <FormItem label="职位：">
                                              <Input type="text" v-model.trim="item.position" :maxlength="20"></Input>
                                          </FormItem>
                                      </div>
                                  </div>
                              </div>
                              <FormItem prop="theme" class="form-item-square" label="举报主题：">
                                  <Input v-model.trim="form.theme" placeholder="请输入20字以内" :maxlength="20"></Input>
                              </FormItem>
                              <FormItem prop="content" class="form-item-square" label="举报内容：">
                                  <Input v-model.trim="form.content" class="report-content" type="textarea" placeholder="请输入2000字以内" :maxlength="2000"></Input>
                              </FormItem>

                              <FormItem prop="url" v-if="isIE9" class="form-item-square file-upload" label="附件上传：">
                                  <div class="clearfix upload-container">
                                      <div class="fl">
                                          <div class="upload-wrapper">
                                              <label for="fileupload0">
                                                  <Icon type="ios-plus-empty"></Icon>
                                              </label>
                                              <input id="fileupload0" type="file" v-show="false" name="file" class="input-ie" data-url="/api/web/fileSplitter/upLoad">

                                              <div class="zip-wrapper" v-if="form.files[0].fileKey">
                                                  <img class="zip" src="../assets/images/zip.svg" alt="">
                                                  <img class="zip-close" src="../assets/images/zip-close.svg" alt="" @click.stop="handleDeleteFile(0)">
                                              </div>

                                          </div>
                                          <Spin v-if="isSpinShow1">
                                              <Icon type="load-c" size=18 class="spin-icon-load"></Icon>
                                              <span class="uploda-tip">文件上传中</span>
                                          </Spin>
                                      </div>
                                      <div class="fl">
                                          <div class="upload-wrapper">
                                              <label for="fileupload1">
                                                  <Icon type="ios-plus-empty"></Icon>
                                              </label>
                                              <input id="fileupload1" type="file" v-show="false" name="file" class="input-ie" data-url="/api/web/fileSplitter/upLoad">
                                              <!-- <input type="file" id="file1" name="file" @change="file1Change" class="input-ie" /> -->
                                              <div class="zip-wrapper" v-if="form.files[1].fileKey">
                                                  <img class="zip" src="../assets/images/zip.svg" alt="">
                                                  <img class="zip-close" src="../assets/images/zip-close.svg" alt="" @click.stop="handleDeleteFile(1)">
                                              </div>

                                          </div>
                                          <Spin v-if="isSpinShow2">
                                              <Icon type="load-c" size=18 class="spin-icon-load"></Icon>
                                              <span class="uploda-tip">文件上传中</span>
                                          </Spin>
                                      </div>
                                      <div class="fl">
                                          <div class="upload-wrapper">
                                              <label for="fileupload2">
                                                  <Icon type="ios-plus-empty"></Icon>
                                              </label>
                                              <input id="fileupload2" type="file" name="file" v-show="false" class="input-ie" data-url="/api/web/fileSplitter/upLoad">
                                              <!-- <input type="file" id="file2" name="file" @change="file2Change" class="input-ie" /> -->
                                              <div class="zip-wrapper" v-if="form.files[2].fileKey">
                                                  <img class="zip" src="../assets/images/zip.svg" alt="">
                                                  <img class="zip-close" src="../assets/images/zip-close.svg" alt="" @click.stop="handleDeleteFile(2)">
                                              </div>
                                          </div>
                                          <Spin v-if="isSpinShow3">
                                              <Icon type="load-c" size=18 class="spin-icon-load"></Icon>
                                              <span class="uploda-tip">文件上传中</span>
                                          </Spin>
                                      </div>
                                  </div>
                              </FormItem>
                              <FormItem prop="url" v-if="!isIE9" class="form-item-square file-upload" label="附件上传：">
                                  <div class="clearfix upload-container">
                                      <div class="fl">

                                          <Upload :action="uploadUrl" :show-upload-list="false" :format="['jpg','jpeg','png','mp3','aac','wav','avi','mp4','mov','zip','rar','doc','docx','wps','txt']" :max-size="20480" :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize" :on-success="handleSuccess1" :on-error="handleError1" :on-progress="handleProgress1">
                                              <Button type="ghost" icon="ios-plus-empty" v-if="!form.files[0].fileKey"></Button>
                                              <img class="zip" src="../assets/images/zip.svg" alt="" v-if="form.files[0].fileKey">
                                              <img class="zip-close" src="../assets/images/zip-close.svg" alt="" v-if="form.files[0].fileKey" @click.stop="handleDeleteFile(0)">
                                          </Upload>
                                          <Spin v-if="isSpinShow1">
                                              <Icon type="load-c" size=18 class="spin-icon-load"></Icon>
                                              <span class="uploda-tip">文件上传中</span>
                                          </Spin>
                                      </div>
                                      <div class="fl">
                                          <Upload :action="uploadUrl" :show-upload-list="false" :format="['jpg','jpeg','png','mp3','aac','wav','avi','mp4','mov','zip','rar','doc','docx','wps','txt']" :max-size="20480" :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize" :on-success="handleSuccess2" :on-error="handleError2" :on-progress="handleProgress2">
                                              <Button type="ghost" icon="ios-plus-empty" v-if="!form.files[1].fileKey"></Button>
                                              <img class="zip" src="../assets/images/zip.svg" alt="" v-if="form.files[1].fileKey">
                                              <img class="zip-close" src="../assets/images/zip-close.svg" alt="" v-if="form.files[1].fileKey" @click.stop="handleDeleteFile(1)">
                                          </Upload>
                                          <Spin v-if="isSpinShow2">
                                              <Icon type="load-c" size=18 class="spin-icon-load"></Icon>
                                              <span class="uploda-tip">文件上传中</span>
                                          </Spin>
                                      </div>
                                      <div class="fl">
                                          <Upload :action="uploadUrl" :show-upload-list="false" :format="['jpg','jpeg','png','mp3','aac','wav','avi','mp4','mov','zip','rar','doc','docx','wps','txt']" :max-size="20480" :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize" :on-success="handleSuccess3" :on-error="handleError3" :on-progress="handleProgress3">
                                              <Button type="ghost" icon="ios-plus-empty" v-if="!form.files[2].fileKey"></Button>
                                              <img class="zip" src="../assets/images/zip.svg" alt="" v-if="form.files[2].fileKey">

                                              <img class="zip-close" src="../assets/images/zip-close.svg" alt="" v-if="form.files[2].fileKey" @click.stop="handleDeleteFile(2)">
                                          </Upload>
                                          <Spin v-if="isSpinShow3">
                                              <Icon type="load-c" size=18 class="spin-icon-load"></Icon>
                                              <span class="uploda-tip">文件上传中</span>
                                          </Spin>
                                      </div>
                                  </div>
                              </FormItem>
                              <FormItem class="form-item-square">
                                  <p class="tips">(附件最大为20M，可上传格式为jpg、jpeg、png、mp3、aac、wav、avi、mp4、mov、zip、rar、doc、docx、wps、txt)</p>
                              </FormItem>
                          </div>
                      </div>

                      <div class="report-contact-wrapper clearfix">
                          <div class="report-contact  report-contact-right">
                              <h3 class="report-item-title">举报人联系方式</h3>
                              <FormItem prop="applicantName" class="form-item-square" label="姓名：">

                                  <Input v-model="form.applicantName" placeholder="请输入真实姓名" :maxlength="10"></Input>
                                  <p class="report-tips">鼓励实名举报，举报渠道专人管理，举报内容严格保密</p>
                              </FormItem>
                              <FormItem prop="applicantPhone" class="form-item-square phone" label="手机号：">
                                  <Input v-model="form.applicantPhone" :maxlength="11" placeholder="请输入手机号"></Input>
                                  <p class="report-tips">手机号用于向您了解详细情况及补充证据之用，将为您严格保密</p>
                              </FormItem>
                              <!-- <FormItem prop="imgCode" class="form-item-square claearfix img-auth" label="验证码：">
                                  <Input class="authcode-input" v-model="form.imgCode" :maxlength="4" placeholder="请输入验证码"></Input>
                                  <div class="authcode-wrapper fr">
                                      <img :src="codeUrl" alt="" class="imgCode">
                                      <img @click="handleRefreshCode" class="btn-refresh" src="../assets/images/btn-refresh.svg" alt="">
                                  </div>
                                  <p class="error-tips" v-if="errorMsg">{{errorMsg}}</p>
                              </FormItem>
                              <FormItem prop="smsCode" class="form-item-square claearfix" label="动态码：">
                                  <Input class="authcode-input" v-model="form.smsCode" :maxlength="6" placeholder="请输入动态验证码"></Input>
                                  <button type="button" class="authcode fr" v-if="!isDisabled" @click="handleGetAuth">获取动态验证码</button>
                                  <button type="button" class="authcode fr" v-else>{{seconds}}s后重新获取</button>
                                  <p class="error-tips" v-if="smsErrorMsg">{{smsErrorMsg}}</p>
                              </FormItem> -->
                              <FormItem prop="applicantEmail" class="form-item-square" label="邮箱：">
                                  <Input v-model="form.applicantEmail" placeholder="请输入邮箱"></Input>
                              </FormItem>
                              <FormItem prop="name">
                                  <p class="tips">您的举报信息对我们很重要，我们会独立管理、严格保密。</p>
                              </FormItem>
                              <div class="btn-wrapper">
                                  <a href="javascript:;" class="btn-primary" @click="handleSubmit('form')">提交</a>
                              </div>
                          </div>
                      </div>
                  </div>
              </Form>
          </div>
      </div>
      <Modal v-model="successModal" title="提示" class="success-modal" :mask-closable="false" :closable="false">
          <p class="icon"><img src="../assets/images/success.svg" alt=""></p>
          <p class="success">举报成功</p>
          <p class="success-tips">您的举报已收到，感谢支持！请您保持联系方式畅通，以便与您联系核实举报信息。</p>
          <div slot="footer" class="footer">
              <!-- <a href="javascript:;" class="btn-primary" @click="handleBackIndex">返回首页</a> -->
              <a href="javascript:;" class="btn-primary" @click="handleGoOn">继续举报</a>
          </div>
      </Modal>

  </div>
</template>
<script>
import clickoutside from '@/directives/clickoutside'
import dataStatistics from '@/assets/js/dataStatistics'
import Header from '@/components/Header'
import api from '@/api/api'
import { authCodeMixin } from '@/mixins/authCodeMixin'
import { backIndexMixin } from '@/mixins/backIndexMixin'
export default {
  name: 'pigReportContent',
  mixins: [authCodeMixin, backIndexMixin],
  components: {
      Header
  },
  directives: { clickoutside },
  data() {
      const validatePhone = (rule, value, callback) => {
          const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
          if (value === '') {
              callback(new Error('请输入手机号'));
          } else if (!reg.test(value)) {
              callback(new Error('请输入正确的手机号码'));
          } else {
              callback();
          }
      };
      const validateItemId = (rule, value, callback) => {
          if (value === '') {
              callback(new Error('请选择举报事项'));
          } else {
              callback();
          }
      };
      return {
          isIE9: false,
          isSpinShow1: false,
          isSpinShow2: false,
          isSpinShow3: false,
          successModal: false,
          isDropDown: false,
          isLight: false,
          isMenuLight: false,
          isDisabled: false,
          seconds: 60,
          personIndex: 1,
          companyIndex: 1,
          source: 1,
          errorMsg: '',
          smsErrorMsg: '',
          form: {
              itemId: '',
              applicantEmail: '',
              applicantName: '',
              applicantPhone: '',
              content: '',
              entityType: [],
              imgCode: '',
              imgTimeStamp: '',
              phone: '',
              smsCode: '',
              smsTimeStamp: '',
              theme: '',
              files: [
                  { fileName: '', fileKey: '' },
                  { fileName: '', fileKey: '' },
                  { fileName: '', fileKey: '' }
              ],
              persons: [
                  {
                      name: '',
                      empId: '',
                      department: '',
                      position: '',
                      type: 1,
                      index: 1
                  }
              ],
              companys: [
                  {
                      name: '',
                      position: '',
                      companyName: '',
                      department: '',
                      type: 2,
                      index: 1
                  }
              ]
          },
          ruleValidate: {
              itemId: [{ validator: validateItemId, trigger: 'change' }],
              theme: [
                  { required: true, message: '请输入举报主题', trigger: 'blur' },
                  { type: 'string', min: 2, message: '限制2-20字符', trigger: 'blur' }
              ],
              // imgCode: [
              //     { required: true, message: '请输入验证码', trigger: 'blur' }
              // ],
              // smsCode: [
              //     { required: true, message: '请输入动态验证码', trigger: 'blur' }
              // ],
              content: [
                  { required: true, message: '请输入举报内容', trigger: 'blur' },
                  { type: 'string', min: 2, message: '限制2-2000字符', trigger: 'blur' }
              ],
              applicantPhone: [
                  { required: true, validator: validatePhone, trigger: 'blur' }
              ],
              entityType: [
                  { required: true, type: 'array', min: 1, message: '请选择员工类型', trigger: 'change' }
              ],
              applicantEmail: [{ type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }]
          },
          list: [],
          selectedList: [],
          codeUrl: '',
          timeInterval: null
      }
  },
  // beforeRouteEnter(to, from, next) {
  //     next(vm => {
  //         if (from.path.toLowerCase() !== '/reportonline') {
  //             vm.$router.push({
  //                 path: '/reportOnline'
  //             })
  //         }
  //     })
  // },
  created() {
      this.getReportTypeList()
      if (navigator.userAgent.indexOf("MSIE 9.0") > 0) {
          this.isIE9 = true
      }
      dataStatistics('PC-举报投诉页', '进入','在线举报')
  },
  mounted() {
      if (navigator.userAgent.indexOf("MSIE 9.0") > 0) {
          const vm = this
          for (var i = 0; i < 3; i++) {
              (function (i) {
                  $('#fileupload' + i).fileupload({
                      dataType: 'iframe text',
                      forceIframeTransport: true,
                      maxFileSize: 20000000,
                      acceptFileTypes: /(.|\/)(jpe?g|png)$/i,
                      add: function (e, data) {
                          if (!/.(jpg|jpeg|png|mp3|aac|wav|avi|mp4|mov|zip|rar|doc|docx|wps|txt)$/.test(data.files[0].name)) {
                              vm.$Message.error('文件格式错误');
                              return
                          }
                          vm.form.files[i].fileName = data.files[0].name
                          data.submit()
                          vm['isSpinShow' + (i + 1)] = true
                      },
                      success: function (data) {
                          var data = JSON.parse(data)

                          if (data.code == 200) {
                              vm.form.files[i].fileKey = data.data.key

                              vm.$Message.success('文件上传成功');

                          } else {
                              vm.$Message.error('文件上传失败');
                          }
                          vm['isSpinShow' + (i + 1)] = false
                      },
                      error: function () {
                          vm.$Message.error('文件上传失败');
                          vm['isSpinShow' + (i + 1)] = false
                      }
                  });
              })(i)
          }
      }

  },
  methods: {
      // 继续举报 直接刷新页面（为了方便0_0）
      handleGoOn() {
          location.reload()
      },
      // 提交举报
      handleSubmit(name) {
          this.$refs[name].validate((valid) => {
              if (valid) {
                  this.handleReport()
              }
          })
      },
      // 举报
      handleReport() {
          const data = Object.assign({}, this.form, {
              source: this.source
          })
          //添加举报渠道
          // data.channelType = this.$route.query['channelType']
        // 员工类型 如果都选 传3
          data.entityType = data.entityType.length !== 2 ? data.entityType.toString() : '3'

          // 举报人员列表
          const list = []
          // 如果选则了 滴滴员工
          if (this.form.entityType.indexOf('1') !== -1) {
              data.persons.forEach(item => {
                  if (item.name) {
                      list.push(item)
                  }
              })
          }
          // 如果选则了合作伙伴
          if (this.form.entityType.indexOf('2') !== -1) {
              data.companys.forEach(item => {
                  if (item.companyName) {
                      list.push(item)
                  }
              })
          }
          data.persons = list
          delete data.companys
          const formData = data
          api.report.reportHonghu(formData).then(res => {
            if (res.data.code === 200) {
              this.errorMsg = ''
              this.smsErrorMsg = ''
              this.successModal = true
              // this.handleRefreshCode()
              clearInterval(this.timeInterval)
              this.isDisabled = false
              this.seconds = 60
            }
          })
      },
      // 获取短信验证码
      handleGetAuth() {
          // 校验是否输入了手机号 与 短信验证码
          this.$refs.form.validateField('imgCode');
          this.$refs.form.validateField('applicantPhone');
          this.errorMsg = ''
          this.$nextTick(() => {
              if (document.querySelector('.phone .ivu-form-item-error-tip') || document.querySelector('.img-auth .ivu-form-item-error-tip')) {
                  return
              }
              this.smsErrorMsg = ''
              this.smsCodeTime = Date.parse(new Date())
              const formData = this.$qs.stringify({
                  phone: this.form.applicantPhone,
                  timeStamp: this.smsCodeTime,
                  imgCode: this.form.imgCode,
                  imgTimeStamp: this.imgCodeTime
              })

              this.getSms(formData)
              this.isDisabled = true
              this.handleTimeInterval()
          })
      },
      // 倒计时
      handleTimeInterval() {
          this.timeInterval = setInterval(() => {
              this.seconds--
              if (this.seconds <= 0) {
                  clearInterval(this.timeInterval)
                  this.isDisabled = false
                  this.seconds = 60
              }
          }, 1000);
      },
      // 关闭下拉列表
      handleClose() {
          this.isDropDown = false
      },
      // 选则举报事项
      handleChoose(index) {
          if (this.list[index].url) {
              window.open(this.list[index].url, '_blank')
          }
          if (JSON.stringify(this.selectedList).indexOf(JSON.stringify(this.list[index])) == -1) {
              this.selectedList.push(this.list[index])
          }
          this.$set(this.list[index], 'sleceted', true)
          this.form.itemId = this.selectedList.map(item => item.id).toString()
      },
      // 移除举报事项
      handleRemove(index) {
          this.list.forEach((item, i) => {
              if (item.id === this.selectedList[index].id) {
                  this.$set(this.list[i], 'sleceted', false)
              }
          });
          this.selectedList.splice(index, 1)
          this.form.itemId = this.selectedList.map(item => item.id).toString()
      },
      // 添加滴滴员工
      handleAddPerson() {
          if (this.reportCount >= 5) {
              this.$Message.error('最多添加5个人员')
              return
          }
          this.personIndex++;
          this.form.persons.push({
              name: '',
              empId: '',
              department: '',
              position: '',
              type: 1,
              index: this.personIndex
          });

      },
      // 删除滴滴员工
      handleDeletePerson(index) {
          if (this.form.persons.length === 1) {
              if (this.form.entityType.length == 2) {
                  this.form.entityType = ['2']
              } else {
                  this.form.entityType = []
              }
              for (var key in this.form.persons[0]) {
                  if(key!=='type') {
                      this.form.persons[0][key] = ''
                  }

              }
              return
          }
          this.form.persons.splice(index, 1)
      },
      //添加合作伙伴
      handleAddCompany() {
          if (this.reportCount >= 5) {
              this.$Message.error('最多添加5个员工')
              return
          }
          this.companyIndex++;
          this.form.companys.push({
              name: '',
              position: '',
              companyName: '',
              department: '',
              type: 2,
              index: this.companyIndex
          });
      },
      // 删除合作伙伴
      handleDeleteCompany(index) {
          if (this.form.companys.length === 1) {
              if (this.form.entityType.length == 2) {
                  this.form.entityType = ['1']

              } else {
                  this.form.entityType = []
              }
              for (var key in this.form.companys[0]) {
                  if(key!=='type') {
                      this.form.companys[0][key] = ''
                  }

              }
              return
          }
          this.form.companys.splice(index, 1)
      },
      // 获取举报事项列表
      getReportTypeList() {
          const params = {
              classCode: 'REPORT',
              isOuter: 0
          }
          api.report.reportTypeList(params).then(res => {
              if (res.data.code === 200) {
                  this.list = res.data.data.filter(item => {
                      return Object.assign({}, item, {
                          selected: false
                      })
                  })
                  // for (let index in this.list) {
                  //     // 回显上一页所选举报事项
                  //     if (this.list[index].id == this.$route.query.reportTypeId) {
                  //         this.selectedList.push(this.list[index])
                  //         this.$set(this.list[index], 'sleceted', true)
                  //         this.form.itemId = this.$route.query.reportTypeId
                  //         break
                  //     }
                  // }
              }
          })
      },
      // 上传中
      handleProgress1() {
          this.isSpinShow1 = true
      },
      handleProgress2() {
          this.isSpinShow2 = true
      },
      handleProgress3() {
          this.isSpinShow3 = true
      },
      // 格式错误
      handleFormatError() {
          this.$Message.error('文件格式错误');
      },
      handleMaxSize() {
          this.$Message.error('文件大小超限');
      },
      // 上传失败
      handleError1() {
          this.isSpinShow1 = false
          this.$Message.error('文件上传失败');
      },
      handleError2() {
          this.isSpinShow2 = false
          this.$Message.error('文件上传失败');
      },
      handleError3() {
          this.isSpinShow3 = false
          this.$Message.error('文件上传失败');
      },
      // 删除文件
      handleDeleteFile(index) {
          this.form.files[index].fileKey = ''
          this.form.files[index].fileName = ''
      },
      // 上传成功
      handleSuccess1(res, file) {
          if (res.code == 200) {
              this.form.files[0].fileKey = res.data.key
              this.form.files[0].fileName = file.name
              this.isSpinShow1 = false
              this.$Message.success('文件上传成功');
          } else {
              this.isSpinShow1 = false
              this.$Message.error('文件上传失败');
          }
      },
      handleSuccess2(res, file) {
          if (res.code == 200) {
              this.form.files[1].fileKey = res.data.key
              this.form.files[1].fileName = file.name
              this.isSpinShow2 = false
              this.$Message.success('文件上传成功');
          } else {
              this.isSpinShow2 = false
              this.$Message.error('文件上传失败');
          }
      },
      handleSuccess3(res, file) {
          if (res.code == 200) {
              this.form.files[2].fileKey = res.data.key
              this.form.files[2].fileName = file.name
              this.isSpinShow3 = false
              this.$Message.success('文件上传成功');
          } else {
              this.isSpinShow3 = false
              this.$Message.error('文件上传失败');
          }
      },
      handleCheckbox(v) {
          if (v.indexOf('1') === -1) {
              this.form.persons = [{
                  name: '',
                  empId: '',
                  department: '',
                  position: '',
                  type: 1,
                  index: this.personIndex,
              }]
              this.personIndex = 1
          }
          if (v.indexOf('2') === -1) {
              this.form.companys = [{
                  name: '',
                  position: '',
                  companyName: '',
                  department: '',
                  type: 2,
                  index: this.companyIndex
              }]
              this.companyIndex = 1
          }
          if (this.form.persons.length === 5) {
              this.$Message.error('最多添加5个员工')
              if (this.form.entityType.length == 2) {
                  this.form.entityType = ['1']
              }
          }
          if (this.form.companys.length === 5) {
              this.$Message.error('最多添加5个员工')
              if (this.form.entityType.length === 2) {
                  this.form.entityType = ['2']
              }
          }

      }
  },
  computed: {
      personSelected() {
          return this.form.entityType.indexOf('1') !== -1
      },
      companySelected() {
          return this.form.entityType.indexOf('2') !== -1
      },
      uploadUrl() {
          return this.$axios.defaults.baseURL + api.base.fileUpload
      },
      reportCount() {
          if (this.form.entityType.length === 2) {
              return this.form.persons.length + this.form.companys.length
          } else {
              return this.form.persons.length + this.form.companys.length - 1
          }
      }
  },
  beforeDestroy() {
      clearInterval(this.timeInterval)
  }
}
</script>
<style lang="less" scoped>

.header {
  padding: 0.25rem 0.3rem 0.25rem;
  position: fixed;
  width: 100%;
  z-index: 666;
  top: 0;
  left: 0;
  background-color: #f5f5f5;
  transition: all 0.8s ease;
  font-size: 20px;
  font-weight: 600;
}
.container {
padding-top: 100px;
margin-bottom: 50px;
}
.form-item-square {
margin-bottom: 30px;
/deep/ .ivu-form-item-error-tip {
  font-size: 14px;
}
/deep/ .ivu-input {
  border: 1px solid #d0d0d0;
  border-radius: 3px;
  height: 36px;
  font-size: 14px;
  color: #000000;
  &:focus {
    box-shadow: 0 0 0 0;
  }
}
/deep/ .ivu-form-item-label {
  padding: 0;
  height: 36px;
  line-height: 36px;
  font-size: 16px;
}
/deep/ .ivu-form-item-content {
  line-height: 36px;
}
.authcode-input {
  width: 65%;
}
}
.report-contact-wrapper {
width: 49%;
float: left;
&:first-child {
  border-right: 1px solid #d5d5d5;
}
}
.report-contact {
width: 480px;
}
.report-contact-right {
margin-left: 1.5rem;
}
.report-contact-left {
float: right;
margin-right: 1.2rem;
}

.report-item-title {
font-family: PingFangSC-Regular;
font-size: 24px;
color: #000000;
text-align: center;
font-weight: normal;
margin-bottom: 0.3rem;
padding-left: 80px;
}
.tips {
font-family: PingFangSC-Regular;
font-size: 14px;
text-align: justify;
color: #999999;
line-height: 1.5;
}
.authcode {
display: block;
border: 1px solid #ff7d41;
border-radius: 3px;
height: 36px;
line-height: 36px;
width: 110px;
text-align: center;
font-family: PingFangSC-Regular;
font-size: 12px;
color: #ff7d41;
background: #ffffff;
outline: 0;
}
.authcode-wrapper {
width: 110px;
}
.query-type {
.ivu-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  right: 20px;
  font-size: 16px;
}
/deep/ .ivu-input {
  cursor: pointer;
}
}

.person-type {
/deep/ .ivu-form-item-label {
  height: 36px;
  line-height: 36px;
}
/deep/ .ivu-checkbox-wrapper {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #000000;
}
/deep/ .ivu-form-item-content {
  line-height: 36px;
  height: 36px;
}
}
.report-content {
/deep/ .ivu-input {
  height: 1.2rem;
  font-size: 14px;
}
}

.file-upload {
/deep/ .ivu-form-item-label {
  padding: 0;
}
/deep/ .ivu-upload {
  width: 1rem;
  height: 1rem;
  .ivu-btn {
    width: 100%;
    height: 100%;
    border-radius: 0;
    border: 1px solid #d0d0d0;
  }
}
/deep/ .ivu-icon-ios-plus-empty {
  font-size: 60rem/75;
  font-weight: bold;
  color: #cacaca;
}
/deep/ .ivu-upload-select {
  position: relative;
  background-color: #fff;

  border: 1px solid #d0d0d0;
}
/deep/ .ivu-btn {
  border: none !important;
}
.zip {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 25px;
  height: 25px;
}
}
.zip-close {
position: absolute;
top: 0;
right: 0;
margin-top: -10px;
margin-right: -10px;
cursor: pointer;
}
.btn-wrapper {
margin-top: 100px;
text-align: center;
padding-left: 100px;
.btn-primary {
  background: #ff7d41;
  border-radius: 100px;
  text-align: center;
  width: 120px;
  height: 38px;
  line-height: 38px;
  display: inline-block;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #ffffff;
}
}
.report-list {
background: #eaeaea;
border-radius: 3px;
padding-top: 10px;
padding-right: 14px;
font-size: 14px;
margin-left: 80px;
font-family: PingFangSC-Regular;
overflow: hidden;
.top {
  margin-bottom: 15px;
  padding-left: 10px;
  color: #666666;
}
/deep/ .ivu-form-item {
  width: 50%;
  float: left;
  height: 32px;
}
/deep/ .ivu-form-item-label {
  width: 60px !important;
  font-size: 14px;
}
/deep/ .ivu-form-item-content {
  margin-left: 60px !important;
}
/deep/ .ivu-form-item-error-tip {
  white-space: nowrap;
  font-size: 12px;
}
}
.btn-group {
font-size: 0;
.btn-handle {
  font-size: 14px;
  cursor: pointer;
}
.btn-add {
  margin-right: 20px;
}
}
.query-type-list-wrapper {
position: absolute;
top: 100%;
z-index: 10;
overflow-y: auto;
max-height: 2.5rem;
border: 1px solid #999999;
border-radius: 3px;
width: 100%;
}
.query-type-list {
background: #ffffff;
padding: 0.1rem 0;
.item {
  padding: 0 20px;
  font-size: 16px;
  height: 0.5rem;
  line-height: 0.5rem;
  cursor: pointer;
  &:hover {
    background: #f2f2f2;
  }
}
.sleceted {
  background: #f2f2f2;
}
}
.multi-select {
width: 100%;
border: 1px solid #d0d0d0;
border-radius: 3px;
min-height: 36px;
font-size: 14px;
background: #fff;
padding-left: 10px;
padding-right: 50px;
.multi-select-placeholder {
  color: #999;
}
.tag {
  display: inline-block;
  height: 22px;
  line-height: 22px;
  margin: 2px 4px 2px 0;
  padding: 0 8px;
  border: 1px solid #e9eaec;
  border-radius: 3px;
  background: #f7f7f7;
  font-size: 12px;
  vertical-align: middle;
  opacity: 1;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  padding-right: 20px;
  .ivu-icon {
    right: 8px;
    font-size: 18px;
    font-weight: 700;
  }
}
}
.imgCode {
display: inline-block;
height: 36px;
width: 85px;
vertical-align: middle;
}
.btn-refresh {
position: absolute;
top: 50%;
right: 0;
width: 20px;
height: 20px;
transform: translateY(-50%);
-ms-transform: translateY(-50%);
-moz-transform: translateY(-50%);
-webkit-transform: translateY(-50%);
-o-transform: translateY(-50%);
cursor: pointer;
}
.report-tips {
position: absolute;
font-size: 14px;
line-height: 1.5;
color: #999999;
top: 40px;
white-space: nowrap;
}
.error-tips {
position: absolute;
top: 100%;
left: 0;
line-height: 1;
padding-top: 6px;
font-size: 14px;
color: #ef4747;
z-index: 10;
background-color: #f5f5f5;
}
.success-modal {
/deep/ .ivu-modal-header {
  font-size: 16px;
}
/deep/ .ivu-modal-body {
  padding-left: 50px;
  padding-right: 50px;
}
.icon {
  text-align: center;
}
.success {
  text-align: center;
  font-size: 14px;
  margin: 15px 0;
}
.success-tips {
  font-size: 14px;
}
.footer {
  text-align: center;
  padding: 10px 0;
  font-size: 16px;
  .btn-primary {
    color: #ff7d41;
    font-size: 14px;
    padding: 0 20px;
  }
}
}
.ivu-spin {
.ivu-icon {
  margin-right: 5px;
  position: relative;
  top: 2px;
}
}
.fl {
margin-right: 30px;
}
.phone {
/deep/ .ivu-form-item-error-tip {
  width: 500px;
  background: #f5f5f5;
  padding-top: 8px;
}
}
.upload-wrapper {
position: relative;
width: 80px;
height: 80px;
border: 1px solid #d0d0d0;
background: #fff;
/deep/ .ivu-icon {
  height: 80px;
  line-height: 80px;
}
label {
  display: inline-block;
  width: 100%;
  height: 100%;
  text-align: center;
}
.zip-close {
  position: absolute;
  width: 20px;
  height: 20px;
}
}
.zip-wrapper {
position: absolute;
width: 80px;
height: 80px;
background: #fff;
top: 0;
left: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/PigReportContent.vue